import React from "react";
import { useSelector } from 'react-redux';
import { Card, CardContent } from "../../ui/card";
import ComponentLoader from '../../../components/ComponentLoader';
import Scatterchart from '../../../components/Scatterchart';
import MapBox from '../../../components/MapBox/MapBox';
import { Wifi } from "lucide-react";

const NetworkMap = ({ userId, onMarkerClick }) => {
  const {data: userRecentActivities, loading: userRecentActivitiesLoading} = useSelector(state => state.UserRecentActivities);

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center gap-2">
            <Wifi className="h-5 w-5 text-indigo-500" />
            <h3 className="font-semibold text-lg">
              Network Analysis
            </h3>
          </div>
        </div>
        <p className="text-sm text-gray-500 mb-4">
          Comprehensive view of network location and performance over time
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Map Visualization */}
          <div className="bg-gray-50 rounded-lg p-2 min-h-0">
            <div className="min-h-[250px] md:min-h-[300px]">
              {userRecentActivitiesLoading && <ComponentLoader />}
              {userRecentActivities && !userRecentActivitiesLoading && (
                <MapBox
                  markers={userRecentActivities?.features}
                  onMapMarkerClick={onMarkerClick}
                  displayOnBoarding={false}
                />
              )}
            </div>
          </div>

          {/* Time Analysis */}
          <div className="bg-gray-50 rounded-lg p-2 min-h-0">
            <div className="min-h-[250px] md:min-h-[300px]">
              <div id="scatter-chart" className="e-chart h-full">
                <Scatterchart sessionId={userId} onMarkerClick={onMarkerClick} />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NetworkMap;
